import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

//Import Icons
class FooterWithoutMenuLightSocialOnly extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <footer className={'footer footer-bar ' + this.props.className}>
          <div className="footer-py-30">
            <Container className="text-center">
              <Row className="align-items-center">
                <Col sm="12">
                  <div className="text-sm-start">
                    <p className="mb-0">
                      © {new Date().getFullYear()} Tecnolimp. Todos os direitos
                      reservados. Rua Francisco Nowotarski, 82 Cep: 81.320-100 –
                      Curitiba-PR
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default FooterWithoutMenuLightSocialOnly;
